var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherY({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6296 12.24C21.7555 11.1142 22.388 9.58722 22.388 7.99504C22.388 6.40285 21.7555 4.87588 20.6296 3.75004C19.5038 2.62419 17.9768 1.9917 16.3846 1.9917C14.7925 1.9917 13.2655 2.62419 12.1396 3.75004L5.38965 10.5V19H13.8896L20.6296 12.24Z",
    stroke: "#FFDD04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3896 8L2.38965 22",
    stroke: "#FFDD04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8896 15H9.38965",
    stroke: "#FFDD04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherY);
export default __webpack_public_path__ + "static/media/icon-feather-y.2b4fd536c03ad5293259cb0b4bb0b745.svg";
export { ForwardRef as ReactComponent };